import { cameraIcon } from '.';

// Custom renderer for cluster markers using a custom SVG icon
export const cameraClusterRenderer = ({
  count,
  position,
}: {
  count: number;
  position: google.maps.LatLng;
}) => {
  // Use external SVG for cluster icon
  const div = document.createElement('div');
  div.style.zIndex = '70';
  div.style.width = '34px';
  div.style.height = '34px';
  div.style.position = 'relative';
  // Add the SVG image
  const img = document.createElement('img');
  img.src = cameraIcon;
  img.width = 34;
  img.height = 34;
  img.style.display = 'block';
  div.appendChild(img);
  // Add the count as overlay text
  const text = document.createElement('span');
  text.textContent = String(count);
  text.style.position = 'absolute';
  text.style.top = '50%';
  text.style.left = '50%';
  text.style.transform = 'translate(-50%, -50%)';
  text.style.color = '#fff';
  text.style.fontSize = '16px';
  text.style.fontWeight = 'bold';
  text.style.pointerEvents = 'none';
  div.appendChild(text);
  // Use AdvancedMarkerElement for custom cluster icon
  return new google.maps.marker.AdvancedMarkerElement({
    position,
    content: div,
    zIndex: 70,
  });
};
